import type { SVGProps } from 'react';

const AlarmWarning = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.49999 3.16666L3.16666 3.49999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.83334V8.00001L9.5 9.50001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.753 8.87774C12.2683 11.5027 9.74735 13.2377 7.12235 12.753C4.49735 12.2683 2.76233 9.74735 3.24708 7.12235C3.73183 4.49735 6.25277 2.76233 8.87774 3.24708"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66668 12L3.83334 12.8333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 12L12.1667 12.8333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3.16666V4.83332"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3333 6.66668C12.3333 6.85074 12.1841 7.00001 12 7.00001C11.8159 7.00001 11.6667 6.85074 11.6667 6.66668C11.6667 6.48258 11.8159 6.33334 12 6.33334C12.1841 6.33334 12.3333 6.48258 12.3333 6.66668Z"
      stroke="currentColor"
      strokeWidth="0.666667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AlarmWarning;
